<template>
  <b-form class="" @submit.prevent="validationForm">
    <b-form-row>
      <b-col>
        <b-form-group label="اسم المستخدم" label-for="username">
          <validation-provider
            mode="passive"
            #default="{ errors }"
            name="اسم المستخدم"
            rules="required"
          >
            <b-form-input
              id="username"
              v-model="form.username"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-form-row>
    <!-- password -->
    <b-form-row>
      <b-col>
        <b-form-group label="كلمة السر" label-for="password">
          <validation-provider
            mode="passive"
            #default="{ errors }"
            name="كلمة السر"
            rules="required|min:8"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid' : null"
            >
              <b-form-input
                id="password"
                v-model="form.password"
                :type="passwordFieldType"
                :state="errors.length > 0 ? false : null"
                class="form-control-merge"
                name="password"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIcon"
                  class="cursor-pointer"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="تأكيد كلمة السر" label-for="confirm">
          <validation-provider
            mode="passive"
            #default="{ errors }"
            name="تأكيد كلمة السر"
            rules="required|confirmed:كلمة السر"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid' : null"
            >
              <b-form-input
                id="confirm"
                v-model="form.confirm_password"
                :type="confirmFieldType"
                :state="errors.length > 0 ? false : null"
                class="form-control-merge"
                name="register-password"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="confirmToggleIcon"
                  class="cursor-pointer"
                  @click="toggleConfirmVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-form-row>
    <!-- submit button -->
    <!-- <b-button variant="success" block type="submit">إنشاء حساب</b-button> -->
  </b-form>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BForm,
  BFormRow,
  BCol,
  BButton,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";

export default {
  components: {
    VuexyLogo,
    // BSV
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BFormRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  props: {
    value: Object,
  },
  data() {
    return {
      regEmail: "",
      username: "",
      password: "",
      status: "",
      confirmFieldType: "password",
      // validation rules
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    confirmToggleIcon() {
      return this.confirmFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    form: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    validationForm() {
      this.$refs.registerForm.validate().then((success) => {
        if (success) {
          this.$emit("validationSuccess");
          resolve(true);
        } else {
          reject(false);
        }
      });
    },
    toggleConfirmVisibility() {
      this.confirmFieldType =
        this.confirmFieldType === "password" ? "text" : "password";
    },
  },
};
</script>

<style lang="scss">
.auth-wrapper.auth-v1 .auth-inner {
  max-width: 400px !important;
}
</style>
